<template>
  <div>
    <validation-observer ref="observer">
      <base-box title="被保險人資料建置">
        <v-container grid-list-md>
          <v-layout
                  row
                  wrap
                  class="form">
            <v-flex sm6>
              <sub-header class="required">
                <template v-slot:title>與要保險人關係?</template>
              </sub-header>
              <b-auto-or-select v-model="cusInfo.relationOwnerCode"
                                v-checker
                                :items="relationList"
                                item-text="codeName"
                                item-value="codeValue"
                                :search-input.sync="relationOwnerCodeSync"
                                :disabled="isReadOnly"
                                label="請選擇"
                                rules="required"
                                vname="與要保人關係"
                                vid="relationOwnerCode"
                                mode="lazy"></b-auto-or-select>
            </v-flex>
            <v-flex sm6
                    v-if="cusInfo.relationOwnerCode === '6'">
              <sub-header><template v-slot:title>其他</template>
              </sub-header>
              <b-text-field placeholder="請輸入"
                            :disabled="isReadOnly"
                            v-model="cusInfo.relationOwnerOther"
                            v-checker
                            maxlength="5"
                            rules="required"
                            vname="其他"
                            vid="relationOther"
                            mode="lazy"
                            outline></b-text-field>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm12>
              <font color='red'>*原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件。</font>
            </v-flex>
            <v-flex sm6>
              <sub-header class="required"><template
                          v-slot:title>{{ idnLabel }}</template>
              </sub-header>
              <div class="d-flex">
                <div style="width: 100%;padding-top:5px">
                  <b-text-field v-model="cusInfo.cusIdn"
                                v-checker
                                @input="cusIdnHandler($event)"
                                @change="idnChange"
                                placeholder="請輸入"
                                :disabled="isReadOnly || isSameOwner || idnReadOnly"
                                :rules="cusIdnRules"
                                :vname="idnLabel"
                                vid="cusIdn"
                                mode="lazy"
                                v-mask="'XXXXXXXXXX'"
                                maxlength="10"
                                @blur="idnInputFetchIdnCusData(cusInfo.cusIdn)"
                                outline></b-text-field>
                </div>
                <div>
                  <v-btn outline
                         fab
                         small
                         :disabled="isReadOnly || isSameOwner"
                         v-ripple=true
                         @click="$event => showIdnDialog()">
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-flex>

            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>姓名</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs12>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner || nameReadOnly"
                                v-model="cusInfo.cusName"
                                :rules="cusNameRules"
                                vname="姓名"
                                vid="cusName"
                                maxlength="20"
                                mode="lazy"
                                @blur="cusInfo.cusName =  checkEsapiRule(cusInfo.cusName,'rule1')"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>性別</template>
              </sub-header>
              <b-base-yn v-model="cusInfo.sex"
                         v-checker
                         :disabled="isReadOnly || isSameOwner || sexReadOnly"
                         :items="sexList"
                         :rules="(!isSameOwner)?'required|gender:nationality,cusIdn':''"
                         vname="性別"
                         :immediate="(cusInfo.cusIdn && cusInfo.cusIdn.length >= 2 && true)"
                         vid="sex"></b-base-yn>
            </v-flex>

            <v-flex sm6>
              <sub-header class="required"><template
                          v-slot:title>出生日期(民國年)</template>
              </sub-header>
              <b-select-date v-model="cusInfo.birthday"
                             :disabled="isReadOnly || isSameOwner || birthReadOnly"
                             v-checker
                             placeholder="請輸入"
                             maxlength="10"
                             :rules="(!isSameOwner)?'required':''"
                             vname="出生日期"
                             vid="birthday"
                             dateMode="3"
                             mode="lazy"
                             :prop-year="cusInfo.birthYy"
                             :prop-month="cusInfo.birthMm"
                             :prop-day="cusInfo.birthDd"
                             @input-year="(val) => { cusInfo.birthYy = val }"
                             @input-month="(val) => { cusInfo.birthMm = val }"
                             @input-day="(val) => { cusInfo.birthDd = val }"
                             outline></b-select-date>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>國籍</template>
              </sub-header>
              <b-auto-or-select v-model="cusInfo.nationality"
                                v-checker
                                :items="countryList"
                                s-tag="autocomplete"
                                item-text="countryName"
                                item-value="countryCode"
                                :search-input.sync="nationalitySync"
                                :filter="nationalityFilter"
                                :disabled="isReadOnly || isSameOwner || nationalReadOnly  || (polInsureType === 'R' && remoteNativeYn === 'Y')"
                                label="請選擇"
                                :rules="{'required':!isSameOwner}"
                                vname="國籍"
                                vid="nationality"
                                mode="lazy"></b-auto-or-select>
            </v-flex>

            <v-flex sm6>
              <sub-header class="required"><template
                          v-slot:title>保險年齡</template>
              </sub-header>
              <sub-content>{{cusInfo.insureAge}} 歲</sub-content>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm12>
              <sub-header class="required"><template
                          v-slot:title>戶籍地址</template>
              </sub-header>

              <v-btn color="secondary"
                     dark
                     :disabled="isReadOnly || isSameOwner"
                     style="border-radius: 10%;min-width: 70px;height: 40px"
                     @click="showAddrSelect('R')">
                地址選擇
              </v-btn>
            </v-flex>
            <v-flex sm10>
              <b-text-field v-model="cusInfo.addrFullR"
                            class="mt-1"
                            v-checker
                            :disabled="true"
                            placeholder="戶籍地址"
                            maxlength="80"
                            :rules="addressRRequired"
                            vname="戶籍地址"
                            vid="addressR"
                            mode="lazy"
                            outline></b-text-field>

            </v-flex>
            <v-flex sm2>
              <v-btn color="primary"
                     dark
                     :disabled="isReadOnly || isSameOwner"
                     style="border-radius: 10%;min-width: 70px;height: 40px"
                     @click="cleanAddresR">
                清除
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm12>
              <sub-header class=""><template v-slot:title>住所地址</template>
              </sub-header>

              <v-layout row
                        wrap
                        class="form">
                <v-flex sm2>
                  <v-btn color="secondary"
                         dark
                         :disabled="isReadOnly || cusInfo.sameAddrYn==='Y' || isSameOwner"
                         style="border-radius: 10%;min-width: 70px;height: 40px"
                         @click="showAddrSelect('L')">
                    地址選擇
                  </v-btn>
                </v-flex>
                <v-flex sm6
                        mt-1>
                  <v-checkbox v-model="cusInfo.sameAddrYn"
                              v-checker
                              :disabled="isReadOnly || isSameOwner"
                              hide-details
                              false-value="N"
                              true-value="Y"
                              label="同戶籍地址"></v-checkbox>

                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm10>
              <b-text-field v-model="cusInfo.addrFull"
                            v-checker
                            :disabled="true"
                            placeholder="住所地址"
                            maxlength="80"
                            :rules="addressRequired"
                            vname="住所地址"
                            vid="address"
                            mode="lazy"
                            outline></b-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn color="primary"
                     dark
                     :disabled="isReadOnly || cusInfo.sameAddrYn==='Y' || isSameOwner"
                     style="border-radius: 10%;min-width: 70px;height: 40px"
                     @click="cleanAddres">
                清除
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template
                          v-slot:title>婚姻狀態</template>
              </sub-header>

              <b-base-yn v-model="cusInfo.marryCode"
                         v-checker
                         :disabled="isReadOnly || isSameOwner"
                         :items="marryCodeList"
                         :rules="{'required':!isSameOwner}"
                         vname="婚姻狀態"
                         vid="marryCode"></b-base-yn>
            </v-flex>
          </v-layout>

        </v-container>
      </base-box>
      <base-box title="聯絡電話 <font color='red'>* （公司電話、住家電話和行動電話需擇一填入；遠距投保時行動電話為必填）</font>">
        <v-container grid-list-md>
          <validation-observer v-slot="{errors}">
            <error-messages
                            :value="phoneErrorsHandler(errors)"></error-messages>
            <v-layout row
                      wrap
                      class="form">
              <validation-provider vid="phoneCheck"
                                   name="公司電話、住家電話和行動電話需擇一填入，請確認!"
                                   :rules="{'required_prefix0':!isSameOwner}"
                                   :immediate="phoneStr().length > 0">
                <input :value="phoneStr()"
                       style="height:0;width:0"
                       id="phoneCheck" />
              </validation-provider>
              <v-flex sm6>
                <sub-header><template v-slot:title>公司電話-分機</template>
                </sub-header>
                <v-layout align-center>
                  <b-text-field v-model="cusInfo.phoneC1"
                                v-checker
                                maxlength="4"
                                class="flex-phone mr-1"
                                placeholder="區碼"
                                :disabled="isReadOnly || isSameOwner"
                                :rules="(!isSameOwner)?'min:2|required_if:phoneC2':''"
                                vname="區碼"
                                vid="phoneC1"
                                hide-details
                                mode="lazy"
                                :error-messages-hidden="true"
                                @blur="cusInfo.phoneC1 = number(cusInfo.phoneC1)"
                                outline></b-text-field>-
                  <b-text-field v-model="cusInfo.phoneC2"
                                ref="cusInfo_phoneC2_ctrl"
                                v-checker
                                :id="'keyId_for_'+cusInfo.phoneC2"
                                maxlength="8"
                                placeholder="公司電話"
                                :disabled="isReadOnly || isSameOwner"
                                class="ml-1 mr-1"
                                hide-details
                                :rules="phoneCRules()"
                                vname="公司電話"
                                vid="phoneC2"
                                mode="lazy"
                                :error-messages-hidden="true"
                                @blur="cusInfo.phoneC2 = number(cusInfo.phoneC2)"
                                outline></b-text-field>#
                  <v-text-field v-model="cusInfo.phoneC3"
                                v-checker
                                maxlength="5"
                                class="flex-extension ml-1"
                                placeholder="分機"
                                hide-details
                                :disabled="isReadOnly || isSameOwner"
                                @blur="cusInfo.phoneC3 = number(cusInfo.phoneC3)"
                                outline></v-text-field>
                </v-layout>
                <error-messages :value="phoneErrorsHandler(errors,'phoneC')"
                                style="margin-top:0px!important;height:38px!important">
                </error-messages>
              </v-flex>
              <v-flex sm6>
                <sub-header><template v-slot:title>住家電話</template>
                </sub-header>
                <v-layout align-center>
                  <b-text-field v-model="cusInfo.phoneH1"
                                v-checker
                                maxlength="4"
                                class="flex-phone mr-1"
                                placeholder="區碼"
                                hide-details
                                :disabled="isReadOnly || isSameOwner"
                                :rules="(!isSameOwner)?'min:2|required_if:phoneH2':''"
                                vname="區碼"
                                vid="phoneH1"
                                mode="lazy"
                                :error-messages-hidden="true"
                                @blur="cusInfo.phoneH1 = number(cusInfo.phoneH1)"
                                outline></b-text-field>-
                  <b-text-field v-model="cusInfo.phoneH2"
                                ref="cusInfo_phoneH2_ctrl"
                                v-checker
                                maxlength="8"
                                placeholder="住家電話"
                                :disabled="isReadOnly || isSameOwner"
                                class="ml-1 mr-1"
                                hide-details
                                :rules="phoneHRules()"
                                vname="住家電話"
                                vid="phoneH2"
                                mode="lazy"
                                :error-messages-hidden="true"
                                @blur="cusInfo.phoneH2 = number(cusInfo.phoneH2)"
                                outline></b-text-field>#
                  <v-text-field v-model="cusInfo.phoneH3"
                                v-checker
                                maxlength="5"
                                class="flex-extension ml-1"
                                placeholder="分機"
                                hide-details
                                :disabled="isReadOnly || isSameOwner"
                                @blur="cusInfo.phoneH3 = number(cusInfo.phoneH3)"
                                outline></v-text-field>
                </v-layout>
                <error-messages :value="phoneErrorsHandler(errors,'phoneH')"
                                style="margin-top:0px!important;height:38px!important">
                </error-messages>
              </v-flex>
            </v-layout>
            <v-layout row
                      wrap
                      class="form">
              <v-flex sm6>
                <sub-header><template v-slot:title>行動電話</template>
                </sub-header>
                <b-text-field v-model="cusInfo.mobile"
                              v-checker
                              maxlength="10"
                              placeholder="請輸入"
                              :disabled="isReadOnly || isSameOwner"
                              :rules="mobileRules"
                              vname="行動電話"
                              vid="mobile"
                              mode="lazy"
                              :error-messages-hidden="true"
                              @blur="cusInfo.mobile = number(cusInfo.mobile)"
                              outline></b-text-field>

                  <error-messages :value="phoneErrorsHandler(errors,'mobile')">
                  </error-messages>
                  <div style="margin-bottom: 20px">
                    <font v-if="polInsureType === 'R'" color='red'>請務必詢問客戶手機號碼,若未填則將收到照會通知</font>
                  </div>
              </v-flex>

              <v-flex sm6>
                <sub-header><template v-slot:title>E-mail</template>
                </sub-header>
                <b-text-field v-model="cusInfo.email"
                              v-checker
                              :disabled="isReadOnly || isSameOwner"
                              type="email"
                              placeholder="請輸入"
                              maxlength="40"
                              :rules="emailRules"
                              vname="E-Mail"
                              vid="email"
                              @blur="cusInfo.email = fullToHalf(checkEsapiRule(cusInfo.email,'rule3'))"
                              outline></b-text-field>
              </v-flex>

            </v-layout>
          </validation-observer>

<!-- fix: SCR #82813 , 移除此處的職業輸入 , fix: Issue #86744 要/被保人職業選單還原-->
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm6>
              <sub-header class="required"><template v-slot:title>職業</template>
              </sub-header>
              <b-auto-or-select v-model="cusInfo.jobCode"
                                v-checker
                                :items="jobsList"
                                s-tag="autocomplete"
                                item-text="showName"
                                item-value="careerCode"
                                :search-input.sync="jobsSync"
                                :filter="jobsFilter"
                                :disabled="isReadOnly || isSameOwner"
                                label="請選擇"
                                :rules="{'required':!isSameOwner}"
                                vname="職業"
                                vid="jobCode"
                                mode="lazy"></b-auto-or-select>
              <div style="margin-bottom: 20px">
                <font color='red'>提醒：若非本國銀行職員，僅為證券或期貨員工請選擇006一般金融業</font>
              </div>
            </v-flex>
          </v-layout>

        </v-container>
      </base-box>

      <base-box title="財務狀況">
      <table class="table table-bordered  ">
          <tbody>
            <tr>
              <th style="width: 20%">項目</th>
              <th style="width: 20%">前次</th>
              <th style="width: 20%">本次</th>
              <th>異動原因</th>
            </tr>
            <tr>
              <td class="required">工作年收入(萬元)</td>
              <td>{{ cusInfo.salaryLast }}</td>
              <td>
                <b-text-field placeholder="請輸入"
                                class="mt-4"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.salary"
                                :rules="salaryCheckRule"
                                vname="工作年收入(萬元)"
                                vid="salary"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.salary = checkDecimal(cusInfo.salary, 5, 1)"
                                outline></b-text-field>
              </td>
              <td>
                <b-textarea placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needSalaryReason() || isSameOwner"
                                v-model="cusInfo.salaryReason"
                                :rules="(needSalaryReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="salaryReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">其他收入(萬元)</td>
              <td>{{ cusInfo.oIncomeLast }}</td>
              <td>
                <b-text-field placeholder="請輸入"
                                class="mt-4"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.oIncome"
                                :rules="oIncomeCheckRule"
                                vname="其他收入(萬元)"
                                vid="oInCome"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.oIncome = checkDecimal(cusInfo.oIncome, 5, 1)"
                                outline></b-text-field>
              </td>
              <td>
                <b-textarea placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needOInComeReason() || isSameOwner"
                                v-model="cusInfo.oIncomeReason"
                                :rules="(needOInComeReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="oIncomeReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">家庭年收入(萬元)</td>
              <td>{{ cusInfo.hIncomeLast }}</td>
              <td>
                <b-text-field placeholder="請輸入"
                                class="mt-4"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.hIncome"
                                :rules="hIncomeCheckRule"
                                vname="家庭年收入(萬元)"
                                vid="hInCome"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.hIncome = checkDecimal(cusInfo.hIncome, 5, 1)"
                                outline></b-text-field>
              </td>
              <td>
                <b-textarea placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needHInComeReason() || isSameOwner"
                                v-model="cusInfo.hIncomeReason"
                                :rules="(needHInComeReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="hIncomeReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_動產(萬元)</td>
              <td  rowspan="2">{{ cusInfo.assetsLast }}</td>
              <td>
                <b-text-field placeholder="請輸入"
                                class="mt-3"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.pp"
                                :rules="(!isSameOwner)?'required|isDecimalPoint:5,1':''"
                                vname="總資產_動產(萬元)"
                                vid="pp"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.pp = checkDecimal(cusInfo.pp, 5, 1)"
                                outline></b-text-field>
              </td>
              <td rowspan="2">
                <b-textarea placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needAssetsReason() || isSameOwner"
                                v-model="cusInfo.assetsReason"
                                :rules="(needAssetsReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="assetsReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_不動產(萬元)</td>
              <td>
                <b-text-field placeholder="請輸入"
                                class="mt-3"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.rp"
                                :rules="(!isSameOwner)?'required|isDecimalPoint:5,1':''"
                                vname="總資產_不動產(萬元)"
                                vid="rp"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.rp = checkDecimal(cusInfo.rp, 5, 1)"
                                outline></b-text-field>
              </td>
            </tr>
            <tr>
              <td>貸款與負債(萬元)</td>
              <td></td>
              <td>
                <b-text-field placeholder="請輸入"
                                v-checker
                                class="mt-4"
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.loanDebt"
                                :rules="(!isSameOwner)?'isDecimalPoint:5,1':''"
                                vname="貸款與負債(萬元)"
                                vid="loanDebt"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.loanDebt = checkDecimal(cusInfo.loanDebt, 5, 1)"
                                outline></b-text-field>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <template v-if="false">
        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header><template v-slot:title>工作年收入(萬元)–前次</template>
              </sub-header>
              <div>
                {{ cusInfo.salaryLast }}
              </div>
            </v-flex>

            <v-flex sm3>
              <sub-header class="required"><template
                          v-slot:title>工作年收入(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.salary"
                                :rules="salaryCheckRule"
                                vname="工作年收入(萬元)"
                                vid="salary"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.salary = checkDecimal(cusInfo.salary, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex sm6>
              <sub-header><template v-slot:title>工作年收入(萬元)–異動原因</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs12>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needSalaryReason() || isSameOwner"
                                v-model="cusInfo.salaryReason"
                                :rules="(needSalaryReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="salaryReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-container>

        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header><template v-slot:title>其他收入(萬元)–前次</template>
              </sub-header>
              <div>
                {{ cusInfo.oIncomeLast }}
              </div>
            </v-flex>

            <v-flex sm3>
              <sub-header class="required"><template
                          v-slot:title>其他收入(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.oIncome"
                                :rules="oIncomeCheckRule"
                                vname="其他收入(萬元)"
                                vid="oInCome"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.oIncome = checkDecimal(cusInfo.oIncome, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex sm6>
              <sub-header><template v-slot:title>其他收入(萬元)–異動原因</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs12>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needOInComeReason() || isSameOwner"
                                v-model="cusInfo.oIncomeReason"
                                :rules="(needOInComeReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="oIncomeReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-container>

        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header><template v-slot:title>家庭年收入(萬元)–前次</template>
              </sub-header>
              <div>
                {{ cusInfo.hIncomeLast }}
              </div>
            </v-flex>

            <v-flex sm3>
              <sub-header class="required"><template
                          v-slot:title>家庭年收入(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.hIncome"
                                :rules="hIncomeCheckRule"
                                vname="家庭年收入(萬元)"
                                vid="hInCome"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.hIncome = checkDecimal(cusInfo.hIncome, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex sm6>
              <sub-header><template v-slot:title>家庭年收入(萬元)–異動原因</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs12>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needHInComeReason() || isSameOwner"
                                v-model="cusInfo.hIncomeReason"
                                :rules="(needHInComeReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="hIncomeReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-container>

        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header><template v-slot:title>總資產_動產+不動產(萬元)–前次</template>
              </sub-header>
              <div>
                {{ cusInfo.assetsLast }}
              </div>
            </v-flex>

            <v-flex sm3>
              <sub-header class="required"><template
                          v-slot:title>總資產_動產(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.pp"
                                :rules="(!isSameOwner)?'required|isDecimalPoint:5,1':''"
                                vname="總資產_動產(萬元)"
                                vid="pp"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.pp = checkDecimal(cusInfo.pp, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex sm6>
              <sub-header><template v-slot:title>總資產_動產+不動產(萬元)–異動原因</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs12>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || !needAssetsReason() || isSameOwner"
                                v-model="cusInfo.assetsReason"
                                :rules="(needAssetsReason() && !isSameOwner)?'required':''"
                                vname="異動原因"
                                vid="assetsReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-container>

        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header />
            </v-flex>
            <v-flex sm3>
              <sub-header class="required"><template
                          v-slot:title>不動產(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.rp"
                                :rules="(!isSameOwner)?'required|isDecimalPoint:5,1':''"
                                vname="不動產(萬元)–本次"
                                vid="rp"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.rp = checkDecimal(cusInfo.rp, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex sm3>
              <sub-header />
            </v-flex>
            <v-flex sm3>
              <sub-header><template v-slot:title>貸款與負債(萬元)–本次</template>
              </sub-header>
              <v-layout row
                        wrap>
                <v-flex xs10>
                  <b-text-field placeholder="請輸入"
                                v-checker
                                :disabled="isReadOnly || isSameOwner"
                                v-model="cusInfo.loanDebt"
                                :rules="(!isSameOwner)?'isDecimalPoint:5,1':''"
                                vname="貸款與負債(萬元)"
                                vid="loanDebt"
                                maxlength="7"
                                mode="lazy"
                                @blur="cusInfo.loanDebt = checkDecimal(cusInfo.loanDebt, 5, 1)"
                                outline></b-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>
        </v-container>
        </template>

      </base-box>

    </validation-observer>
    <base-btn>
      <btn-lg-default class="float-left"
                      :disabled="isPreview"
                      @click="resetHandler">全部清除</btn-lg-default>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <btn-lg-primary :disabled="disableNext" @click="nextStepHandlerController">下一步</btn-lg-primary>
    </base-btn>
    <btn-lg-default style="position: fixed;top: 300px;right: 30px;min-width: 126px;max-width: 126px;" @click="preStepHandler" >上一步</btn-lg-default>
    <btn-lg-primary style="position: fixed;top: 360px;right: 30px;min-width: 126px;" :disabled="disableNext" @click="nextStepHandlerController" >下一步</btn-lg-primary>

    <base-dialog-adm v-if="idnDialogShow"
                    :show="idnDialogShow"
                    :title="`請輸入${idnLabel}`"
                    width="500"
                    @close="closeIdnDialog"
                    @save="saveIdnDialog">
      <idn-card-dialog ref="idnCardDialogRef"
                       :trans-code="transCode"
                       :comp-code="compCode"
                       :national-code="cusInfo.nationality"
                       :input-error="idnError"
                       :idn-label="idnLabel"
                       :chk-remote-native-yn="chkRemoteNativeYn"
                       :chk-agent-idno="chkAgentIdno"
                       @getCusData="getCusData"></idn-card-dialog>
    </base-dialog-adm>

    <select-address v-if="showAddressSelect"
            :prop-addr="address"
            @confirmlog="addrConfirmLog"
            @commit="commitAddrSelect"
            @close="closeAddrSelect"
    >
    </select-address>
  </div>
</template>

<script>
import addressApi from '@/components/Ins/Policy/AddressApi.js'
import IdnCardDialog from '@/components/Ins/Policy/IdnCardDialog'
import SelectAddress from '@/components/Ins/Policy/SelectAddress.vue'
import { esapi, halfFull, policyChangedChecker } from '@/mixin'
import { getActualAge, getInsureAge, withDebounce } from '@/utils'
import { filter, map, reduce, isEmpty } from 'lodash'
import {
  isNationalIdentificationNumberValid,
  isResidentCertificateNumberValid
} from 'taiwan-id-validator'
import { createNamespacedHelpers } from 'vuex'
import ProposalStepsBase from '../ProposalStepsBase'
const { mapActions } = createNamespacedHelpers('ins')
const { mapActions: commonMapActions } = createNamespacedHelpers('common')
const { mapGetters: commonMapGetters } = createNamespacedHelpers('common')
const isDev = process.env.NODE_ENV === 'development'
export default {

  extends: ProposalStepsBase,

  mixins: [halfFull, policyChangedChecker, esapi, addressApi],

  components: { IdnCardDialog, SelectAddress },

  props: {
    showExempt: {
      type: Boolean
    },
    aCusIdn: {
      type: String
    }
  },

  data () {
    return {
      isReadOnly: this.isPreview,
      initOk: false,
      idnLabel: '身分證/居留證號碼',
      disableNext: false,
      idnDialogShow: false,
      showAddressSelect: false,
      sameOwner: false,
      cusInfoTypeO: {

      },
      cusInfo: {
        cusCode: '',
        getDataYn: '', // 是否透過發查取得客戶資料
        relationOwner: '', // 與要保險人關係
        relationOwnerOther: '',
        cusIdn: '', // 身分證/居留證號碼
        cusName: '', // 姓名
        sex: '', // 性別
        birthday: '', // 出生日期
        birthYy: '', // 出生日期-年
        birthMm: '', // 出生日期-月
        birthDd: '', // 出生日期-日
        insureAge: '', // 保險年齡
        actualAge: '', // 實際年齡
        nationality: '', // 國家代碼
        addrFullR: '', // 戶藉地址
        addrFull: '', // 住所地址
        sameAddrYn: '', // 同戶籍地址
        addrCityR: '', // 戶藉地址-縣市
        addrAreaR: '', // 戶藉地址-區域
        addrZipCodeR: '', // 戶藉地址-郵遞區號
        addrRoadR: '', // 戶藉地址-路名
        addrLaneR: '', // 戶藉地址-巷
        addrAlleyR: '', // 戶藉地址-弄
        addrLonR: '', // 戶藉地址-衖
        addrNumR: '', // 戶藉地址-號
        addrNumOfR: '', // 戶藉地址-號之
        addrFloorR: '', // 戶藉地址-樓
        addrFloorOfR: '', // 戶藉地址-樓之
        addrRoomR: '', // 戶藉地址-室
        addrCity: '', // 住所地址-縣市
        addrArea: '', // 住所地址-區域
        addrZipCode: '', // 住所地址-郵遞區號
        addrRoad: '', // 住所地址-路名
        addrLane: '', // 住所地址-巷
        addrAlley: '', // 住所地址-弄
        addrLon: '', // 住所地址-衖
        addrNum: '', // 住所地址-號
        addrNumOf: '', // 住所地址-號之
        addrFloor: '', // 住所地址-樓
        addrFloorOf: '', // 住所地址-樓之
        addrRoom: '', // 住所地址-室
        marryCode: '', // 婚姻狀況
        phoneC: '', // 公司電話
        phoneC1: '', // 公司電話-區碼
        phoneC2: '', // 公司電話-電話
        phoneC3: '', // 公司電話-分機
        phoneH: '', // 住家電話
        phoneH1: '', // 住家電話-區碼
        phoneH2: '', // 住家電話-電話
        phoneH3: '', // 住家電話-分機
        mobile: '', // 行動電話
        email: '', // email
        jobCode: '', // 職業代碼
        salaryLast: '', //
        salary: '', // 工作年收入
        salaryReason: '', // 工作年收入-異動原因
        oIncomeLast: '', //
        oIncome: '', // 其他收入
        oIncomeReason: '', // 其他收入-異動原因
        hIncomeLast: '', //
        hIncome: '', // 家庭年收入
        hIncomeReason: '', // 家庭年收入-異動原因
        assetsLast: '', //
        assets: '', // 總資產_動產+不動產
        assetsReason: '', // 總資產_動產+不動產-異動原因
        loanDebt: '', // 貸款與負債
        amlResult: '' // 是否透過AML發查取得客戶資料
      },
      cusFinanceIdn: '',
      cusFinanceData: null,
      idnReadOnly: false,
      nameReadOnly: false,
      sexReadOnly: false,
      birthReadOnly: false,
      nationalReadOnly: false,
      address: {
        type: '', // R: 戶藉地址, L: 住所地址
        transCode: '',
        compCode: '',
        addrCity: '', // 縣市
        addrArea: '', // 區域
        addrZipCode: '', // 郵遞區號
        addrRoad: '', // 路名
        addrLane: '', // 巷
        addrAlley: '', // 弄
        addrLon: '', // 衖
        addrNum: '', // 號
        addrNumOf: '', // 號之
        addrFloor: '', // 樓
        addrFloorOf: '', // 樓之
        addrRoom: '' // 室
      },
      relationOwnerCodeSync: null,
      nationalitySync: null,
      jobsSync: null,
      idnError: '',
      chkRemoteNativeYn: false,
      chkAgentIdno: '',
      insAddrCheckYn: '', // add for SCR #96622 , 地址正規化開關 (ADM_PARMD-S01)
      addrCheckFullR: '', // 戶籍地址的『完整地址 狀態
      addrCheckFull: '', // 住所地址的『完整地址』狀態
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.init()
    })
  },

  created () {

  },

  computed: {
    ...commonMapGetters([
      'cityList',
      'areaMap'
    ]),
    relationList () {
      return this.$store.getters['common/admCodeDetail']({
        codeType: 'RELATION_OWNER_CODE'
      })
    },
    isSameOwner () {
      return this.cusInfo.relationOwnerCode === '1'
    },
    remoteNativeYn () {
      // (ADM_PARMD-S01) 遠距是否限本國人
      let { parameterValue: yn } = this.insParameters['REMOTE_NATIVE_YN']
      return yn
    },
    highAgeLimit () {
      // (ADM_PARMD-S01) 高齡年齡限制
      let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    sexList () {
      let list = this.$store.getters['common/admCodeDetail']({
        codeType: 'SEX'
      })
      list = map(list, v => {
        return { text: v.codeName, value: v.codeValue }
      })
      return list
    },
    marryCodeList () {
      let list = this.$store.getters['common/admCodeDetail']({
        codeType: 'MARRY_CODE'
      })
      list = map(list, v => {
        return { text: v.codeName, value: v.codeValue }
      })
      return list
    },
    cusIdnRules () {
      if (this.isSameOwner) {
        return ''
      }
      let rules = 'required|min:10'
      const { nationality, cusIdn } = this.cusInfo

      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        if (!isNationalIdentificationNumberValid(cusIdn) && cusIdn && cusIdn.length == 10) {
          // 身分證驗證
          rules = `${rules}|showMsg:身分證號碼有誤，遠距投保只限本國自然人，請確認!`
          return rules
        }

      }

      if (!nationality) {
        if (isNationalIdentificationNumberValid(cusIdn)) {
          // 身分證驗證
          rules = `${rules}|twId`
        } else if (isResidentCertificateNumberValid(cusIdn)) {
          // 居留證驗證
          rules = `${rules}|residentId`
        } else {
          rules = `${rules}|twId`
        }
      } else if (nationality === 'TW') {
        // 身分證驗證
        rules = `${rules}|twId`
      } else if (nationality !== 'TW') {
        // 居留證驗證
        rules = `${rules}|residentId`
      }

      if (this.polInsureType === 'R') {
        let admUsers = this.$store.getters["common/admUserInfo"]
        if (cusIdn === admUsers.idno) {
          rules += '|showMsg:遠距投保不得為自保件！'
        }
      }

      return rules
    },
    cusNameRules () {
      if (this.isSameOwner) {
        return ''
      }
      let rules = 'required'
      const { nationality, cusName } = this.cusInfo
      if (cusName && nationality && nationality === 'TW') {
        let showMsg = ''
        if (this.hasBlankChar(cusName)) {
          showMsg += '姓名不能有空白!'
        }
        if (this.hasSpecialChar(cusName)) {
          showMsg += '原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件!'
        }
        if (showMsg) {
          rules += '|showMsg:' + showMsg
        }
      } else if (cusName && nationality) {
        let showMsg = ''
        if (this.hasSpecialChar(cusName)) {
          showMsg += '原住民長姓名(指特殊字)、姓名/地址有難字及受監護宣告客戶皆需改採紙本進件!'
        }
        if (showMsg) {
          rules += '|showMsg:' + showMsg
        }
      }
      return rules
    },
    addressRRequired () {
      if (this.isSameOwner) {
        return ''
      }
      /* 改成不判個別欄位，只判完整欄位
      if (!(this.cusInfo.addrCityR) || !(this.cusInfo.addrAreaR) || !(this.cusInfo.addrZipCodeR) || !(this.cusInfo.addrRoadR)) {
        return 'showMsg:請輸入 完整戶籍地址'
      }
      return ''
      */
      return 'required'
    },
    addressRequired () {
      if (this.isSameOwner) {
        return ''
      }
      /* 改成不判個別欄位，只判完整欄位
      if (!(this.cusInfo.addrFull)) {
        return ''
      }
      if (!(this.cusInfo.addrCity) || !(this.cusInfo.addrArea) || !(this.cusInfo.addrZipCode) || !(this.cusInfo.addrRoad)) {
        return 'showMsg:請輸入 完整住所地址'
      }
      return ''
      */
      return ''
    },
    mobileRules () {
      if (this.isSameOwner) {
        return ''
      }

      let rules = 'min:10|mobilePhone2'


      if (this.polInsureType === 'R' && !this.cusInfo.mobile) {
        rules += '|showMsg:遠距投保時行動電話為必填，請確認!'
      }

      return rules
    },

    emailRules () {
      if (this.isSameOwner) {
        return ''
      }
      if ((this.cusInfo.emailYn === 'Y' || this.cusInfo.agreeEmailYn === 'Y') && !this.cusInfo.email) {
        return 'showMsg:請填寫E-mail|email|megaEmail'
      } else {
        return 'email|megaEmail'
      }
    },
    salaryCheckRule() { //add by SCR #93149 ， 調整 工作年收入 檢核
      if(this.isSameOwner){ //與要保人一致，則跳過檢核
        return {}
      }
      let uiName = 'salary'
      let  { relationOwnerCode : relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome } = this.cusInfo
      if(this.cusInfoTypeO){
        o_hIncome= this.cusInfoTypeO.hIncome
        o_salary= this.cusInfoTypeO.salary
        o_oIncome= this.cusInfoTypeO.oIncome
      }
      return {
                required: true,
                isDecimalPoint: ['5','1'],
                checkHIncomeMinFunc: {relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome ,uiName}
             }
    },
    oIncomeCheckRule() { //add by SCR #93149 ， 調整 其他收入 檢核
      if(this.isSameOwner){ //與要保人一致，則跳過檢核
        return {}
      }
      let uiName = 'oIncome'
      let  { relationOwnerCode : relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome } = this.cusInfo
      if(this.cusInfoTypeO){
        o_hIncome= this.cusInfoTypeO.hIncome
        o_salary= this.cusInfoTypeO.salary
        o_oIncome= this.cusInfoTypeO.oIncome
      }
      return {
                required: true,
                isDecimalPoint: ['5','1'],
                checkHIncomeMinFunc: {relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome ,uiName}
             }
    },
    hIncomeCheckRule() { //add by SCR #93149 ， 調整 家庭收入 檢核
      if(this.isSameOwner){ //與要保人一致，則跳過檢核
        return {}
      }
      let uiName = 'hIncome'
      let  { relationOwnerCode : relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome } = this.cusInfo
      if(this.cusInfoTypeO){
        o_hIncome= this.cusInfoTypeO.hIncome
        o_salary= this.cusInfoTypeO.salary
        o_oIncome= this.cusInfoTypeO.oIncome
      }
      return {
                required: true,
                isDecimalPoint: ['5','1'],
                checkHIncomeMinFunc: {relNo, hIncome, salary, oIncome, o_hIncome, o_salary, o_oIncome,uiName}
             }
    },
  },

  watch: {
    relationOwnerCodeSync (v) {
      !v && (this.cusInfo.relationOwnerCode = null)
    },
    nationalitySync (v) {
      if (this.nationalReadOnly) return
      !v && (this.cusInfo.nationality = null)
    },
    jobsSync (v) {
      !v && (this.cusInfo.jobCode = null)
    },
    'cusInfo.relationOwnerCode': {
      handler (v, oldVal) {
        if (v === '1') {
          this.setSameOwner()
        } else {
          if (v && oldVal === '1' && v !== oldVal) {
            const cusCode = this.cusInfo.cusCode
            const relationOwnerCode = v
            this.cusInfo = { ...this.$options.data().cusInfo, cusCode, relationOwnerCode }

            this.idnReadOnly = false
            this.nameReadOnly = false
            this.sexReadOnly = false
            this.birthReadOnly = false
            this.nationalReadOnly = false

            this.cusTypeICheck = ''
            this.$emit('update-type-i-status', this.cusTypeICheck)

            this.cusTypeIRefAddressR = ''
            this.cusTypeIRefAddress = ''
            this.$emit('update-cus-type-i-ref-address', { cusTypeIRefAddressR: this.cusTypeIRefAddressR, cusTypeIRefAddress: this.cusTypeIRefAddress })

            this.cusTypeIAddressRCheck = 'N'
            this.cusTypeIAddressCheck = 'N'
            this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })

          }
        }
        if (v !== '6') {
          this.cusInfo.relationOwnerOther = ''
        }
      },
      immediate: false
    },
    'cusInfo.birthday': {
      handler (v) {
        if (v) {
          const [
            birthYY = null,
            birthMM = null,
            birthDD = null
          ] = v.split('/')
          if (birthYY && birthMM && birthDD) {
            this.cusInfo.birthYy = birthYY
            this.cusInfo.birthMm = birthMM
            this.cusInfo.birthDd = birthDD

            // 計算保險年齡
            this.recalculateAge()
          }
        } else {
          this.cusInfo.insureAge = ''
          this.cusInfo.actualAge = ''
        }
      }
    },
    'result.nationality': {
      handler (v) {

      },
      immediate: true
    },
    'cusInfo.sameAddrYn': {
      handler (newVal, oldVal) {
        if (newVal === 'Y') {
          this.cusInfo.addrCity = this.cusInfo.addrCityR
          this.cusInfo.addrArea = this.cusInfo.addrAreaR
          this.cusInfo.addrZipCode = this.cusInfo.addrZipCodeR
          this.cusInfo.addrRoad = this.cusInfo.addrRoadR
          this.cusInfo.addrLane = this.cusInfo.addrLaneR
          this.cusInfo.addrAlley = this.cusInfo.addrAlleyR
          this.cusInfo.addrLon = this.cusInfo.addrLonR
          this.cusInfo.addrNum = this.cusInfo.addrNumR
          this.cusInfo.addrNumOf = this.cusInfo.addrNumOfR
          this.cusInfo.addrFloor = this.cusInfo.addrFloorR
          this.cusInfo.addrFloorOf = this.cusInfo.addrFloorOfR
          this.cusInfo.addrRoom = this.cusInfo.addrRoomR

          this.cusInfo.checkAddrYn = this.cusInfo.checkAddrRYn
          this.setAddress()
        } else if (newVal !== 'Y' && oldVal === 'Y') {
          this.cusInfo.addrCity =
          this.cusInfo.addrArea =
          this.cusInfo.addrZipCode =
          this.cusInfo.addrRoad =
          this.cusInfo.addrLane =
          this.cusInfo.addrAlley =
          this.cusInfo.addrLon =
          this.cusInfo.addrNum =
          this.cusInfo.addrNumOf =
          this.cusInfo.addrFloor =
          this.cusInfo.addrFloorOf =
          this.cusInfo.addrRoom =
          this.cusInfo.addrFull = ''
          this.cusInfo.checkAddrYn = ''
        }
      },
      immediate: true
    },
    changedFlag (v) {
      if (v) {
        this.$setTabDone(this.tabStep, false )
      }
    }
  },
  methods: {
    ...mapActions([
      'saveApiLog',
      'fetchCusInfo',
      'postCusInfo',
      'checkAgentService',
      'checkCusName',
      'fetchUserFinance',
      'fetchIdnCusData'
    ]),
    ...commonMapActions(['fetchRoadName','fetchSingleParam']),
    getAjaxInsAddrCheckYn() { //fix: SCR #96622 ，調整 [地址檢核開關] 參數抓取方式
      return this.fetchSingleParam({ type :'INS', code: "INS_ADDR_CHECK_YN" }).then(r =>{
        this.insAddrCheckYn = r.data.parameterValue // 地址檢核開關 參數
      })
    },
    phoneCMerge () {//fix: SCR #96622 , 修正 BUG ，電話處理過程用 computed 方式會有問題，改用 method
      const { phoneC1, phoneC2, phoneC3 } = this.cusInfo
      const isValid = phoneC1 && phoneC2
      let r = ''
      if (isValid) {
        r = phoneC3
          ? `${phoneC1}-${phoneC2}#${phoneC3}`
          : `${phoneC1}-${phoneC2}#`
      } else if (phoneC1 || phoneC2 || phoneC3) {
        const phone_c1 = (phoneC1) || ''
        const phone_c2 = (phoneC2) || ''
        const phone_c3 = (phoneC3) || ''
        r = `${phone_c1}-${phone_c2}#${phone_c3}`
      }
      return r
    },
    phoneHMerge () {//fix: SCR #96622 , 修正 BUG ，電話處理過程用 computed 方式會有問題，改用 method
      const { phoneH1, phoneH2, phoneH3 } = this.cusInfo
      const isValid = phoneH1 && phoneH2
      let r = ''
      if (isValid) {
        r = phoneH3
          ? `${phoneH1}-${phoneH2}#${phoneH3}`
          : `${phoneH1}-${phoneH2}#`
      } else if (phoneH1 || phoneH2 || phoneH3) {
        const phone_h1 = (phoneH1) || ''
        const phone_h2 = (phoneH2) || ''
        const phone_h3 = (phoneH3) || ''
        r = `${phone_h1}-${phone_h2}#${phone_h3}`
      }
      return r
    },
    init () {
      let vm = this
      const { transCode } = vm
      if (transCode) {
        vm.fetchCusInfo({
          transCode,
          actFlag: 'insuredTab', //fix: SCR #84277 ，加上流程旗標
          cusType: ['I', 'O']
        }).then(r => {
          if (r.data) {
            let hasCus = false
            if (r.data.cusList && r.data.cusList.length > 0) {
              r.data.cusList.forEach(e => {
                if (e.cusType === 'I') {
                  vm.cusInfo = { ...e }
                  hasCus = true
                } else if (e.cusType === 'O') {
                  vm.cusInfoTypeO = { ...e }
                }
              })

              if (vm.cusInfo.relationOwner === '1') {
                vm.setSameOwner()
              }

              let preAge = vm.cusInfo.insureAge
              // 計算保險年齡
              vm.recalculateAge()
              if (preAge !== '' && preAge !== vm.cusInfo.insureAge) {
                vm.$alert('提醒您，被保人' + vm.cusInfo.cusName + '年齡有異動。')
              }

              /*
              if (vm.cusInfo.checkAddrRYn === 'P') {
                // vm.cusInfo.addrFullR
              } else {
                vm.setAddressR()
              }
              if (vm.cusInfo.checkAddrYn === 'P') {
                // vm.cusInfo.addrFull
              } else {
                vm.setAddress()
              }
              */

              vm.setPhoneC()
              vm.setPhoneH()
              if (vm.cusInfo.getDataYn === 'Y') {
                vm.idnReadOnly = !vm.cusInfo.cusIdn ? false : true
                vm.nameReadOnly = !vm.cusInfo.cusName ? false : true
                vm.sexReadOnly = !vm.cusInfo.sex ? false : true
                vm.birthReadOnly = !vm.cusInfo.birthday ? false : true
                vm.nationalReadOnly = !vm.cusInfo.nationality ? false : true
              }

              if (hasCus) {
                vm.$nextTick(() => {
                  setTimeout(() => {
                    vm.doValidate()
                  }, 0)
                })
              }
              /*
              if (vm.cusInfo.birthYy || vm.cusInfo.birthMm || vm.cusInfo.birthDd) {
                vm.cusInfo.birthday = `${vm.cusInfo.birthYy}/${vm.cusInfo.birthMm}/${vm.cusInfo.birthDd}`
              }
              */
            }

            if (vm.polInsureType === 'R' && vm.remoteNativeYn === 'Y') {
              vm.idnLabel = '身分證號碼'
              vm.cusInfo.nationality = 'TW'
            }

            vm.initOk = true
          }
        })
      }
      vm.getAjaxInsAddrCheckYn() //fix: SCR #96622 ，調整 [地址檢核開關] 參數抓取方式
    },
    idnChange () {
      this.cusTypeICheck = 'N'
      this.$emit('update-type-i-status', this.cusTypeICheck)
    },
    cusIdnHandler (id) {
      if (id) {
        this.cusInfo.cusIdn = id.toUpperCase()
        if (id.length > 1 && (id[1] === '1' || id[1] === '8' || id[1] === 'A' || id[1] === 'C')) {
          this.cusInfo.sex = '1'
        } else if (id.length > 1 && (id[1] === '2' || id[1] === '9' || id[1] === 'B' || id[1] === 'D')) {
          this.cusInfo.sex = '2'
        } else {
          this.cusInfo.sex = ''
        }
        if (isNationalIdentificationNumberValid(id)) {
          this.cusInfo.nationality = 'TW'
        } else {
          if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
            this.cusInfo.nationality = 'TW'
          } else if (this.cusInfo.nationality === 'TW') {
            this.cusInfo.nationality = ''
          }
        }

        if (isNationalIdentificationNumberValid(id) || isResidentCertificateNumberValid(id)) {
          if (!this.cusFinanceIdn || this.cusFinanceIdn !== id) {
            this.cusFinanceIdn = id
            this.fetchUserFinance({ cusIdn: id, transCode: this.transCode }).then(ret => {
              if (ret.data) {
                this.cusFinanceData = { ...ret.data }
              } else {
                this.cusFinanceData = null
              }
            })
          }
        }
      }
    },
    idnInputFetchIdnCusData (id) {
      if (isNationalIdentificationNumberValid(id) || isResidentCertificateNumberValid(id)) {
        this.cusInfo.salaryLast = ''
        this.cusInfo.oIncomeLast = ''
        this.cusInfo.hIncomeLast = ''
        this.cusInfo.assetsLast = ''
        this.fetchIdnCusData({
          idnCard: id,
          transCode: this.transCode,
          compCode: this.compCode,
          insuredAct : 'Y' //fix: SCR #84277 ， 加上 被保人流程旗標
        }).then(r => {
          if (r.data.status === 'E') {// 失敗
            // this.$alert(r.data.message)
          } else { // 成功
            const result = r.data.cusData
            if (result.hasLastIncome) {
              this.cusInfo.salaryLast = result.salaryLast
              this.cusInfo.oIncomeLast = result.oIncomeLast
              this.cusInfo.hIncomeLast = result.hIncomeLast
              this.cusInfo.assetsLast = result.assetsLast
            }
          }
        })
      }
    },
    changeMsg (list) {
      let newMsg = ''
      if (list.length > 1) {
        let newList = []
        let num = 1
        list.forEach(el => {
          el = '(' + num + ')'  + el
          num++
          newList.push(el)
        })
        newMsg = '<div style="text-align:left">' + newList.join('<br>') + '</div>'
        return newMsg
      } else {
        return '<div style="text-align:left">' + list.join('<br>') + '</div>'
      }
    },
    getCusData (result) {//fix: SCR #96622 ，調整 先抓取 [地址檢核開關] 參數再呼叫的流程
      this.getAjaxInsAddrCheckYn().then(() => {
        this.getCusDataInner(result)
      })
    },
    getCusDataInner (result) {
      this.$postUserAccessLog({ progClassName: 'CusInsured_idn_confirm', methodName: '確定(身分證發查)', stepCode: this.tabStep })

      this.idnError = ''
      /* 這裏的判斷改在idnCardDialog內做
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        if (!isNationalIdentificationNumberValid(result.legcusIdn)) {
          this.idnError = '身分證號碼有誤，遠距投保只限本國自然人，請確認!'
          return
        }
      }
      */

      this.idnDialogShow = false
      this.cusInfo.cusIdn = result.legcusIdn
      this.cusInfo.cusName = result.legcusName
      this.cusInfo.sex = result.legSex
      let birthday = result.legbirthday
      if (birthday) {
        const [birthYY, birthMM, birthDD] = birthday.split('/')
        this.cusInfo.birthYy = (parseInt(birthYY) - 1911).toString().padStart(3, '0')
        this.cusInfo.birthMm  = birthMM
        this.cusInfo.birthDd = birthDD
        this.cusInfo.birthday = this.cusInfo.birthYy + '/' + this.cusInfo.birthMm + '/' + this.cusInfo.birthDd
      }
      const { nationality, nationalReadOnly } = this.resolveNationalityResult(result.legNationality, result.legcusIdn)
      this.cusInfo.nationality = nationality
      this.nationalReadOnly = nationalReadOnly
      this.cusInfo.phoneC2 = result.legPhoneC
      this.cusInfo.phoneH2 = result.legPhoneH
      this.cusInfo.mobile = result.mobile
      //fix: SCR #96622 , 修正 BUG ，強制讓 UI 資料觸發更新
      const ctrl= this.$refs['cusInfo_phoneC2_ctrl']
      ctrl.value = result.legPhoneC
      const ctrl2= this.$refs['cusInfo_phoneH2_ctrl']
      ctrl2.value = result.legPhoneH

      this.cusInfo.email = result.email
      // this.cusInfo.marryCode = result.marryCode
      // 婚姻狀態不存在marryCodeList，不填值
      let marryCodeRet = this.marryCodeList.filter(e => {
        return e.value === result.marryCode
      })
      if (marryCodeRet && marryCodeRet.length > 0) {
        this.cusInfo.marryCode = result.marryCode
      } else {
        this.cusInfo.marryCode = ''
      }

      if (result.hasLastIncome) {
        this.cusInfo.salaryLast = result.salaryLast
        this.cusInfo.oIncomeLast = result.oIncomeLast
        this.cusInfo.hIncomeLast = result.hIncomeLast
        this.cusInfo.assetsLast = result.assetsLast
      } else {
        this.cusInfo.salaryLast = ''
        this.cusInfo.oIncomeLast = ''
        this.cusInfo.hIncomeLast = ''
        this.cusInfo.assetsLast = ''
      }
      this.needSalaryReason()
      this.needOInComeReason()
      this.needHInComeReason()
      this.needAssetsReason()

      this.cusTypeIRefAddressR = '(由保經業管系統或證券開戶資料帶入參考: ' + result.refAddressR + ')'
      this.cusTypeIRefAddress = '(由保經業管系統或證券開戶資料帶入參考: ' + result.refAddress + ')'
      // 要重設地址欄
      this.cusInfo.checkAddrRYn = 'N'
      this.cusInfo.checkAddrYn = 'N'
      this.addrCheckFullR = null
      this.addrCheckFull = null

      this.cusInfo.addrFullR = result.refAddressR
      this.cusInfo.addrCityR =
          this.cusInfo.addrAreaR =
          this.cusInfo.addrZipCodeR =
          this.cusInfo.addrRoadR =
          this.cusInfo.addrLaneR =
          this.cusInfo.addrAlleyR =
          this.cusInfo.addrLonR =
          this.cusInfo.addrNumR =
          this.cusInfo.addrNumOfR =
          this.cusInfo.addrFloorR =
          this.cusInfo.addrFloorOfR =
          this.cusInfo.addrRoomR = ''
      this.cusInfo.addrFull = result.refAddress
      this.cusInfo.sameAddrYn = ''
      this.cusInfo.addrCity =
          this.cusInfo.addrArea =
          this.cusInfo.addrZipCode =
          this.cusInfo.addrRoad =
          this.cusInfo.addrLane =
          this.cusInfo.addrAlley =
          this.cusInfo.addrLon =
          this.cusInfo.addrNum =
          this.cusInfo.addrNumOf =
          this.cusInfo.addrFloor =
          this.cusInfo.addrFloorOf =
          this.cusInfo.addrRoom = ''
      // 做地址正規化
      this.cusTypeIAddressRCheck = 'N'
      this.cusTypeIAddressCheck = 'N'
      let addrCheckMsg = ''
      let addrRCheck = () => {
        addrCheck()
      }
      let addrCheck = () => {
        if (addrCheckMsg) {
          this.$alert(addrCheckMsg, () => {
            finish()
          })
        } else {
          finish()
        }
      }
      if (result.refAddressR) {
        addrRCheck = () => {
          if(this.insAddrCheckYn === 'N'){ // fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
            this.commitAddrSelect(result.refAddressR)
            addrCheck()
            return
          }
          this.addressCheck(result.refAddressR, this.transCode, this.compCode).then(r => {
            if (r.connectError) {
              addrCheckMsg += '戶籍地址正規化檢核連線失敗！關閉訊息後系統將留存您發查之地址'

              this.cusInfo.checkAddrRYn = 'P' // 地址正規化，api錯誤
              this.cusTypeIAddressRCheck = 'Y'
              this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
            } else if (r.code === 'ok1') {
              r.address.type = 'R'
              this.commitAddrSelect(r.address)
            } else if (r.code === 'ok2') {
              r.address.type = 'R'
              this.commitAddrSelect(r.address)
              addrCheckMsg += '戶籍地址門牌整編過，新地址為:' + r.resultAddr + ' 請確認'
            }  else {
              addrCheckMsg += '戶籍' + r.msg
            }
            addrCheck()
          })
        }
      }
      if (result.refAddress) {
        addrCheck = () => {
          if(this.insAddrCheckYn === 'N'){ // fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
            this.commitAddrSelect(result.refAddress)
            finish()
            return
          }
          this.addressCheck(result.refAddress, this.transCode, this.compCode).then(r => {
            if (r.connectError) {
              if (addrCheckMsg) {
                addrCheckMsg += '<br>'
              }
              addrCheckMsg += '住所地址正規化檢核連線失敗！關閉訊息後系統將留存您發查之地址'

              this.cusInfo.checkAddrYn = 'P' // 地址正規化，api錯誤
              this.cusTypeIAddressCheck = 'Y'
              this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
            } else if (r.code === 'ok1') {
              r.address.type = 'L'
              this.commitAddrSelect(r.address)
            } else if (r.code === 'ok2') {
              r.address.type = 'L'
              this.commitAddrSelect(r.address)
              if (addrCheckMsg) {
                addrCheckMsg += '<br>'
              }
              addrCheckMsg += '住所地址門牌整編過，新地址為:' + r.resultAddr + ' 請確認'
            } else {
              if (addrCheckMsg) {
                addrCheckMsg += '<br>'
              }
              addrCheckMsg += '住所' + r.msg
            }
            if (addrCheckMsg) {
              let newMsg = this.changeMsg(addrCheckMsg.split('<br>'))
              this.$alert(newMsg, () => {
                  finish()
                })
            } else {
              finish()
            }
          })
        }
      }
      const finish = () => {
        this.$emit('update-cus-type-i-ref-address', { cusTypeIRefAddressR: this.cusTypeIRefAddressR, cusTypeIRefAddress: this.cusTypeIRefAddress })
        this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })

        this.$alert('請業務員確實詢問客戶，並將電話區碼、號碼、分機(若有)，採分欄個別拆分後填入。').then(() => {
          this.cusInfo.getDataYn = 'Y'
          this.idnReadOnly = !this.cusInfo.cusIdn ? false : true
          this.nameReadOnly = !this.cusInfo.cusName ? false : true
          this.sexReadOnly = !this.cusInfo.sex ? false : true
          this.birthReadOnly = !this.cusInfo.birthday ? false : true
          this.nationalReadOnly = nationalReadOnly

          this.cusInfo.amlResult = result.legAmlResult
          this.cusTypeICheck = 'Y'
          this.$emit('update-type-i-status', this.cusTypeICheck)
        })
      }

      addrRCheck()
    },
    setAddressFromCusData (refAddress, address) {
      // 解析來源地址，取出縣市地區和路
      if (!refAddress) return

      let cityName = ''
      this.cityList.forEach(e => {
        if (!cityName && refAddress.includes(e)) {
          cityName = e
        }
      })
      address.addrCity = cityName

      let areaName = ''
      let zipCode = ''
      if (address.addrCity && this.areaMap[address.addrCity]) {
        this.areaMap[address.addrCity].forEach(e => {
          if (!areaName && refAddress.includes(e.areaName)) {
            areaName = e.areaName
            zipCode = e.zipCode
          }
        })
      }
      address.addrArea = areaName
      address.addrZipCode = zipCode

      let road = ''
      this.address.addrRoad = ''
      if (address.addrCity && address.addrArea) {
        let vm = this
        this.fetchRoadName({
          cityName: address.addrCity,
          areaName: address.addrArea
        }).then(r => {
          if (r.data && r.data.length > 0) {
            r.data.forEach(e => {
              if (!road && refAddress.includes(e.roadName)) {
                road = e.roadName
              }
            })
            this.address.addrRoad = road
          }
        })
      }

      this.address.addrLane = ''
      this.address.addrAlley = ''
      this.address.addrLon = ''
      this.address.addrNum = ''
      this.address.addrNumOf = ''
      this.address.addrFloor = ''
      this.address.addrFloorOf = ''
      this.address.addrRoom = ''
    },
    showIdnDialog () {
      this.$postUserAccessLog({ progClassName: 'CusInsured_idn', methodName: '身分證發查', stepCode: this.tabStep })
      this.idnError = ''
      this.chkRemoteNativeYn = false
      this.chkAgentIdno = ''
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        this.chkRemoteNativeYn = true
      }
      if (this.polInsureType === 'R') {
        let admUsers = this.$store.getters["common/admUserInfo"]
        this.chkAgentIdno = admUsers.idno
      }

      this.idnDialogShow = true
    },
    closeIdnDialog () {
      this.$postUserAccessLog({ progClassName: 'CusInsured_idn_cancel', methodName: '取消(身分證發查)', stepCode: this.tabStep })
      this.idnDialogShow = false
    },
    saveIdnDialog () {
      this.$refs['idnCardDialogRef'].saveHandler()
    },
    cleanAddresR () {
      this.address = { ...this.$options.data().address }
      this.cusInfo.checkAddrRYn = ''
      this.cusInfo.addrFullR =
          this.cusInfo.addrCityR =
          this.cusInfo.addrAreaR =
          this.cusInfo.addrZipCodeR =
          this.cusInfo.addrRoadR =
          this.cusInfo.addrLaneR =
          this.cusInfo.addrAlleyR =
          this.cusInfo.addrLonR =
          this.cusInfo.addrNumR =
          this.cusInfo.addrNumOfR =
          this.cusInfo.addrFloorR =
          this.cusInfo.addrFloorOfR =
          this.cusInfo.addrRoomR = ''
      if (this.cusInfo.sameAddrYn === 'Y') {
        this.cleanAddres()
      }
    },
    cleanAddres () {
      this.address = { ...this.$options.data().address }
      this.cusInfo.checkAddrYn = ''
      this.cusInfo.addrFull =
          this.cusInfo.addrCity =
          this.cusInfo.addrArea =
          this.cusInfo.addrZipCode =
          this.cusInfo.addrRoad =
          this.cusInfo.addrLane =
          this.cusInfo.addrAlley =
          this.cusInfo.addrLon =
          this.cusInfo.addrNum =
          this.cusInfo.addrNumOf =
          this.cusInfo.addrFloor =
          this.cusInfo.addrFloorOf =
          this.cusInfo.addrRoom = ''
    },
    phoneStr () {
      let phoneC = (this.cusInfo.phoneC2)?this.cusInfo.phoneC2:''
      let phoneH = (this.cusInfo.phoneH2)?this.cusInfo.phoneH2:''
      let mobile = (this.cusInfo.mobile)?this.cusInfo.mobile:''
      return phoneC + phoneH + mobile
    },
    phoneCRules () {
      if (this.isSameOwner) return ''
      let rules = 'required_if:phoneC1'
      const { phoneC1, phoneC2 } = this.cusInfo
      if (phoneC1 && phoneC2) {
        if ((phoneC1.length + phoneC2.length) < 9 || (phoneC1.length + phoneC2.length) > 10 ) {
          rules += '|showMsg:區碼+電話限制總長度9~10碼'
        }
      }

      return rules
    },
    phoneHRules () {
      if (this.isSameOwner) return ''
      let rules = 'required_if:phoneH1'
      const { phoneH1, phoneH2 } = this.cusInfo
      if (phoneH1 && phoneH2) {
        if ((phoneH1.length + phoneH2.length) < 9 || (phoneH1.length + phoneH2.length) > 10 ) {
          rules += '|showMsg:區碼+電話限制總長度9~10碼'
        }
      }

      return rules
    },
    needSalaryReason () {
      //fix: Issue #84272 , 財務狀況比對問題修正，數值為0情況下, 會變成沒有判斷成異動
      if (this.cusInfo.salaryLast || this.cusInfo.salaryLast === 0) {
        if (parseFloat(this.cusInfo.salaryLast) !== parseFloat(this.cusInfo.salary)){
          return true
        }
      }
      this.cusInfo.salaryReason = ''
      return false
    },
    needOInComeReason () {
      //fix: Issue #84272 , 財務狀況比對問題修正，數值為0情況下, 會變成沒有判斷成異動
      if (this.cusInfo.oIncomeLast || this.cusInfo.oIncomeLast === 0) {
        if (parseFloat(this.cusInfo.oIncomeLast) !== parseFloat(this.cusInfo.oIncome)){
          return true
        }
      }
      this.cusInfo.oIncomeReason = ''
      return false
    },
    needHInComeReason () {
      //fix: Issue #84272 , 財務狀況比對問題修正，數值為0情況下, 會變成沒有判斷成異動
      if (this.cusInfo.hIncomeLast || this.cusInfo.hIncomeLast === 0) {
        if (parseFloat(this.cusInfo.hIncomeLast) !== parseFloat(this.cusInfo.hIncome)){
          return true
        }
      }
      this.cusInfo.hIncomeReason = ''
      return false
    },
    needAssetsReason () {
      //fix: Issue #84272 , 財務狀況比對問題修正，數值為0情況下, 會變成沒有判斷成異動
      if (this.cusInfo.assetsLast || this.cusInfo.assetsLast === 0) {
        const toMoneyInt = (val) => Math.round(Number(val || 0) * 100)
        const assetsLast = toMoneyInt(this.cusInfo.assetsLast)
        const pp = toMoneyInt(this.cusInfo.pp)
        const rp = toMoneyInt(this.cusInfo.rp)

        if (assetsLast !== pp + rp) {
          return true
        }
      }
      this.cusInfo.assetsReason = ''
      return false
    },
    setPhoneC () {
      if (this.cusInfo.phoneC) {
        const [
          phoneC1 = null,
          phoneC2 = null,
          phoneC3 = null
        ] = this.phoneSplit(this.cusInfo.phoneC)
        this.cusInfo.phoneC1 = phoneC1
        this.cusInfo.phoneC2 = phoneC2
        this.cusInfo.phoneC3 = phoneC3
      }
    },
    setPhoneH () {
      if (this.cusInfo.phoneH) {
        const [
          phoneH1 = null,
          phoneH2 = null,
          phoneH3 = null
        ] = this.phoneSplit(this.cusInfo.phoneH)
        this.cusInfo.phoneH1 = phoneH1
        this.cusInfo.phoneH2 = phoneH2
        this.cusInfo.phoneH3 = phoneH3
      }
    },
    phoneSplit (phone) {
      if (!phone) return []
      phone = phone.replace('#', '-')
      return phone.split('-')
    },
    setSameOwner () {
      const cusCode = this.cusInfo.cusCode
      const relationOwnerCode = this.cusInfo.relationOwnerCode
      const relationOwnerOther = this.cusInfo.relationOwnerOther
      this.cusInfo = {...this.cusInfoTypeO, cusCode, relationOwnerCode, relationOwnerOther}

      this.setPhoneC()
      this.setPhoneH()
    },
    showAddrSelect (type) {
      this.address.type = type
      this.address.transCode = this.transCode
      this.address.compCode = this.compCode

      if (type === 'R') { // 戶籍地址
        if (this.cusInfo.checkAddrRYn !== 'Y' && !(this.cusInfo.checkAddrRYn === 'P' && this.cusInfo.addrCityR)) {
          this.address.refAddress = this.cusInfo.addrFullR
          this.setAddressFromCusData(this.address.refAddress, this.address)
        } else {
          this.address.addrCity = this.cusInfo.addrCityR
          this.address.addrArea = this.cusInfo.addrAreaR
          this.address.addrZipCode = this.cusInfo.addrZipCodeR
          this.address.addrRoad = this.cusInfo.addrRoadR
          this.address.addrLane = this.cusInfo.addrLaneR
          this.address.addrAlley = this.cusInfo.addrAlleyR
          this.address.addrLon = this.cusInfo.addrLonR
          this.address.addrNum = this.cusInfo.addrNumR
          this.address.addrNumOf = this.cusInfo.addrNumOfR
          this.address.addrFloor = this.cusInfo.addrFloorR
          this.address.addrFloorOf = this.cusInfo.addrFloorOfR
          this.address.addrRoom = this.cusInfo.addrRoomR
        }
        if (this.insAddrCheckYn=== 'Y' ) { // 地址正規化開關 =='Y'
          this.cusInfo.checkAddrRYn = 'Y' // 『要保人戶籍地址檢查』= 'Y'
        } else {
          this.cusInfo.checkAddrRYn = 'N' // 『要保人戶籍地址檢查』= 'N'
        }
        this.showAddressSelect = true

        this.$postUserAccessLog({ progClassName: 'CusInsured_selectAddr', methodName: '地址選擇', stepCode: this.tabStep })
      } else if (type === 'L') { // 住所地址
        if (this.cusInfo.checkAddrYn !== 'Y' && !(this.cusInfo.checkAddrYn === 'P' && this.cusInfo.addrCity)) {
          this.address.refAddress = this.cusInfo.addrFull
          this.setAddressFromCusData(this.address.refAddress, this.address)
        } else {
          this.address.addrCity = this.cusInfo.addrCity
          this.address.addrArea = this.cusInfo.addrArea
          this.address.addrZipCode = this.cusInfo.addrZipCode
          this.address.addrRoad = this.cusInfo.addrRoad
          this.address.addrLane = this.cusInfo.addrLane
          this.address.addrAlley = this.cusInfo.addrAlley
          this.address.addrLon = this.cusInfo.addrLon
          this.address.addrNum = this.cusInfo.addrNum
          this.address.addrNumOf = this.cusInfo.addrNumOf
          this.address.addrFloor = this.cusInfo.addrFloor
          this.address.addrFloorOf = this.cusInfo.addrFloorOf
          this.address.addrRoom = this.cusInfo.addrRoom
        }
        if (this.insAddrCheckYn=== 'Y' ) { // 地址正規化開關 =='Y'
          this.cusInfo.checkAddrYn = 'Y' // 『要保人戶籍地址檢查』= 'Y'
        } else {
          this.cusInfo.checkAddrYn = 'N' // 『要保人戶籍地址檢查』= 'N'
        }
        this.showAddressSelect = true

        this.$postUserAccessLog({ progClassName: 'CusInsured_selectAddr', methodName: '地址選擇', stepCode: this.tabStep })
      }
    },
    addrConfirmLog () {
      this.$postUserAccessLog({ progClassName: 'CusInsured_selectAddr_confirm', methodName: '確定(地址選擇)', stepCode: this.tabStep })
    },
    commitAddrSelect (addr) {
      if (addr.type === 'R' && addr.connectError) {
        this.cusInfo.addrCityR = addr.addrCity
        this.cusInfo.addrAreaR = addr.addrArea
        this.cusInfo.addrZipCodeR = addr.addrZipCode
        this.cusInfo.addrRoadR = addr.addrRoad
        this.cusInfo.addrLaneR = addr.addrLane
        this.cusInfo.addrAlleyR = addr.addrAlley
        this.cusInfo.addrLonR = addr.addrLon
        this.cusInfo.addrNumR = addr.addrNum
        this.cusInfo.addrNumOfR = addr.addrNumOf
        this.cusInfo.addrFloorR = addr.addrFloor
        this.cusInfo.addrFloorOfR = addr.addrFloorOf
        this.cusInfo.addrRoomR = addr.addrRoom

        this.cusInfo.checkAddrRYn = 'P' // 地址正規化，api錯誤
        this.cusTypeIAddressRCheck = 'Y'
        this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })

        this.setAddressR()
      } else if (addr.type === 'R') {
        this.cusInfo.addrCityR = addr.addrCity
        this.cusInfo.addrAreaR = addr.addrArea
        this.cusInfo.addrZipCodeR = addr.addrZipCode
        this.cusInfo.addrRoadR = addr.addrRoad
        this.cusInfo.addrLaneR = addr.addrLane
        this.cusInfo.addrAlleyR = addr.addrAlley
        this.cusInfo.addrLonR = addr.addrLon
        this.cusInfo.addrNumR = addr.addrNum
        this.cusInfo.addrNumOfR = addr.addrNumOf
        this.cusInfo.addrFloorR = addr.addrFloor
        this.cusInfo.addrFloorOfR = addr.addrFloorOf
        this.cusInfo.addrRoomR = addr.addrRoom

        this.cusInfo.checkAddrRYn = this.insAddrCheckYn === 'Y' ? 'Y' : 'N'

        this.cusTypeIRefAddressR = '' // 完成後參考地址就不需要了
        this.$emit('update-cus-type-i-ref-address', { cusTypeIRefAddressR: this.cusTypeIRefAddressR, cusTypeIRefAddress: this.cusTypeIRefAddress })

        this.cusTypeIAddressRCheck = 'Y'
        this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })


        this.setAddressR()
      } if (addr.type === 'L' && addr.connectError) {
        this.cusInfo.addrCity = addr.addrCity
        this.cusInfo.addrArea = addr.addrArea
        this.cusInfo.addrZipCode = addr.addrZipCode
        this.cusInfo.addrRoad = addr.addrRoad
        this.cusInfo.addrLane = addr.addrLane
        this.cusInfo.addrAlley = addr.addrAlley
        this.cusInfo.addrLon = addr.addrLon
        this.cusInfo.addrNum = addr.addrNum
        this.cusInfo.addrNumOf = addr.addrNumOf
        this.cusInfo.addrFloor = addr.addrFloor
        this.cusInfo.addrFloorOf = addr.addrFloorOf
        this.cusInfo.addrRoom = addr.addrRoom

        this.cusInfo.checkAddrYn = 'P' // 地址正規化，api錯誤
        this.cusTypeIAddressCheck = 'Y'
        this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })

        this.setAddress()
      } else if (addr.type === 'L') {
        this.cusInfo.addrCity = addr.addrCity
        this.cusInfo.addrArea = addr.addrArea
        this.cusInfo.addrZipCode = addr.addrZipCode
        this.cusInfo.addrRoad = addr.addrRoad
        this.cusInfo.addrLane = addr.addrLane
        this.cusInfo.addrAlley = addr.addrAlley
        this.cusInfo.addrLon = addr.addrLon
        this.cusInfo.addrNum = addr.addrNum
        this.cusInfo.addrNumOf = addr.addrNumOf
        this.cusInfo.addrFloor = addr.addrFloor
        this.cusInfo.addrFloorOf = addr.addrFloorOf
        this.cusInfo.addrRoom = addr.addrRoom

        this.cusInfo.checkAddrYn = this.insAddrCheckYn === 'Y' ? 'Y' : 'N'

        this.cusTypeIRefAddress = '' // 完成後參考地址就不需要了
        this.$emit('update-cus-type-i-ref-address', { cusTypeIRefAddressR: this.cusTypeIRefAddressR, cusTypeIRefAddress: this.cusTypeIRefAddress })

        this.cusTypeIAddressCheck = 'Y'
        this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })


        this.setAddress()
      }

      this.showAddressSelect = false
      this.address = { ...this.$options.data().address }
    },
    closeAddrSelect () {
      this.$postUserAccessLog({ progClassName: 'CusInsured_selectAddr_cancel', methodName: '取消(地址選擇)', stepCode: this.tabStep })
      this.showAddressSelect = false
      this.address = { ...this.$options.data().address }
    },
    isNotUnderground(val) {
      if (val.startsWith('地') || val.startsWith('底')) {
        return false
      }
      return true
    },
    getFullAddrR_forCheck () {
      return ((this.cusInfo.addrCityR)?this.cusInfo.addrCityR:'') +
            ((this.cusInfo.addrAreaR)?this.cusInfo.addrAreaR:'') +
            ((this.cusInfo.addrRoadR)?this.cusInfo.addrRoadR:'') +
            ((this.cusInfo.addrLaneR)?(this.cusInfo.addrLaneR + '巷'): '') +
            ((this.cusInfo.addrAlleyR)?(this.cusInfo.addrAlleyR + '弄'): '') +
            ((this.cusInfo.addrLonR)?(this.cusInfo.addrLonR + '衖'): '') +
            ((this.cusInfo.addrNumR)?(this.cusInfo.addrNumR + '號'): '') +
            ((this.cusInfo.addrNumOfR)?('之' + this.cusInfo.addrNumOfR): '') +
            ((this.cusInfo.addrFloorR)?((this.isNotUnderground(this.cusInfo.addrFloorR))?(this.cusInfo.addrFloorR + '樓'):this.cusInfo.addrFloorR): '') +
            ((this.cusInfo.addrFloorOfR)?('之' + this.cusInfo.addrFloorOfR): '')
    },
    setAddressR () {
      this.cusInfo.addrFullR = ((this.cusInfo.addrZipCodeR)?(this.cusInfo.addrZipCodeR + ' '):'') +
                              ((this.cusInfo.addrCityR)?this.cusInfo.addrCityR:'') +
                              ((this.cusInfo.addrAreaR)?this.cusInfo.addrAreaR:'') +
                              ((this.cusInfo.addrRoadR)?this.cusInfo.addrRoadR:'') +
                              ((this.cusInfo.addrLaneR)?(this.cusInfo.addrLaneR + '巷'): '') +
                              ((this.cusInfo.addrAlleyR)?(this.cusInfo.addrAlleyR + '弄'): '') +
                              ((this.cusInfo.addrLonR)?(this.cusInfo.addrLonR + '衖'): '') +
                              ((this.cusInfo.addrNumR)?(this.cusInfo.addrNumR + '號'): '') +
                              ((this.cusInfo.addrNumOfR)?('之' + this.cusInfo.addrNumOfR): '') +
                              ((this.cusInfo.addrFloorR)?((this.isNotUnderground(this.cusInfo.addrFloorR))?(this.cusInfo.addrFloorR + '樓'):this.cusInfo.addrFloorR): '') +
                              ((this.cusInfo.addrFloorOfR)?('之' + this.cusInfo.addrFloorOfR): '') +
                              ((this.cusInfo.addrRoomR)?(' ' + this.cusInfo.addrRoomR + '室'): '')

      if (this.cusInfo.sameAddrYn === 'Y') {
        this.cusInfo.addrCity = this.cusInfo.addrCityR
        this.cusInfo.addrArea = this.cusInfo.addrAreaR
        this.cusInfo.addrZipCode = this.cusInfo.addrZipCodeR
        this.cusInfo.addrRoad = this.cusInfo.addrRoadR
        this.cusInfo.addrLane = this.cusInfo.addrLaneR
        this.cusInfo.addrAlley = this.cusInfo.addrAlleyR
        this.cusInfo.addrLon = this.cusInfo.addrLonR
        this.cusInfo.addrNum = this.cusInfo.addrNumR
        this.cusInfo.addrNumOf = this.cusInfo.addrNumOfR
        this.cusInfo.addrFloor = this.cusInfo.addrFloorR
        this.cusInfo.addrFloorOf = this.cusInfo.addrFloorOfR
        this.cusInfo.addrRoom = this.cusInfo.addrRoomR

        this.cusInfo.checkAddrYn = this.cusInfo.checkAddrRYn
        this.setAddress()
      }
      this.addrCheckFullR = 'Y' // 戶籍地址的『完整地址 狀態
    },
    getFullAddr_forCheck () {
      return ((this.cusInfo.addrCity)?this.cusInfo.addrCity:'') +
              ((this.cusInfo.addrArea)?this.cusInfo.addrArea:'') +
              ((this.cusInfo.addrRoad)?this.cusInfo.addrRoad:'') +
              ((this.cusInfo.addrLane)?(this.cusInfo.addrLane + '巷'): '') +
              ((this.cusInfo.addrAlley)?(this.cusInfo.addrAlley + '弄'): '') +
              ((this.cusInfo.addrLon)?(this.cusInfo.addrLon + '衖'): '') +
              ((this.cusInfo.addrNum)?(this.cusInfo.addrNum + '號'): '') +
              ((this.cusInfo.addrNumOf)?('之' + this.cusInfo.addrNumOf): '') +
              ((this.cusInfo.addrFloor)?((this.isNotUnderground(this.cusInfo.addrFloor))?(this.cusInfo.addrFloor + '樓'):this.cusInfo.addrFloor): '') +
              ((this.cusInfo.addrFloorOf)?('之' + this.cusInfo.addrFloorOf): '')
    },
    setAddress () {
      this.cusInfo.addrFull = ((this.cusInfo.addrZipCode)?(this.cusInfo.addrZipCode + ' '):'') +
                              ((this.cusInfo.addrCity)?this.cusInfo.addrCity:'') +
                              ((this.cusInfo.addrArea)?this.cusInfo.addrArea:'') +
                              ((this.cusInfo.addrRoad)?this.cusInfo.addrRoad:'') +
                              ((this.cusInfo.addrLane)?(this.cusInfo.addrLane + '巷'): '') +
                              ((this.cusInfo.addrAlley)?(this.cusInfo.addrAlley + '弄'): '') +
                              ((this.cusInfo.addrLon)?(this.cusInfo.addrLon + '衖'): '') +
                              ((this.cusInfo.addrNum)?(this.cusInfo.addrNum + '號'): '') +
                              ((this.cusInfo.addrNumOf)?('之' + this.cusInfo.addrNumOf): '') +
                              ((this.cusInfo.addrFloor)?((this.isNotUnderground(this.cusInfo.addrFloor))?(this.cusInfo.addrFloor + '樓'):this.cusInfo.addrFloor): '') +
                              ((this.cusInfo.addrFloorOf)?('之' + this.cusInfo.addrFloorOf): '') +
                              ((this.cusInfo.addrRoom)?(' ' + this.cusInfo.addrRoom + '室'): '')
      this.addrCheckFull = 'Y' // 住所地址的『完整地址』狀態
    },
    recalculateAge () {
      const { birthYy, birthMm, birthDd } = this.cusInfo
      if (birthYy && birthMm && birthDd) {
        const y = parseInt(birthYy) + 1911
        const m = parseInt(birthMm) - 1
        const d = parseInt(birthDd)
        this.cusInfo.insureAge = getInsureAge(y, m, d)
        this.cusInfo.actualAge = getActualAge(y, m, d)
      }
    },
    checkRemoteAge () {
      let admUsers = this.$store.getters["common/admUserInfo"]
      if (this.polInsureType === 'R' && admUsers.oldAgeEduYn !== 'Y') {
        // 遠距判斷年齡
        if (this.cusInfo.insureAge >= this.highAgeLimit) {
          return false
        }
      }
      return true
    },
    checkAge () {
      let admUsers = this.$store.getters["common/admUserInfo"]
      if (admUsers.oldAgeEduYn !== 'Y') {
        //fix: Issue #108289 ，針對業務員沒有高齡資格，要被保人65歲沒有阻擋，修改判斷由> 改成 >=
        // 判斷高齡年齡限制
        if (this.cusInfo.insureAge >= this.highAgeLimit) {
          return false
        }
      }
      return true
    },
    resetHandler () {
      const cusCode = this.cusInfo.cusCode
      this.cusInfo = { ...this.$options.data().cusInfo, cusCode }

      this.idnReadOnly = false
      this.nameReadOnly = false
      this.sexReadOnly = false
      this.birthReadOnly = false
      this.nationalReadOnly = false
      this.cusTypeICheck = ''
      this.$emit('update-type-i-status', this.cusTypeICheck)

      this.cusTypeIRefAddressR = ''
      this.cusTypeIRefAddress = ''
      this.$emit('update-cus-type-i-ref-address', { cusTypeIRefAddressR: this.cusTypeIRefAddressR, cusTypeIRefAddress: this.cusTypeIRefAddress })

      this.cusTypeIAddressRCheck = 'N'
      this.cusTypeIAddressCheck = 'N'
      this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })

      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        this.idnLabel = '身分證號碼'
        this.cusInfo.nationality = 'TW'
      }

      this.$reset('observer')
      this.$emit('go-top')
      this.$emit('set-validate-num', { step: this.tabStep, num: 0 })

      this.$postUserAccessLog({ progClassName: 'CusInsured_clear', methodName: '全部清除', stepCode: this.tabStep })
    },
    nationalityFilter (item, queryText, itemText) {
      return (
        item.countryCode // 調整為countryCode
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.countryName
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    resolveNationalityResult (apiNationality, idNumber) {
      if (this.polInsureType === 'R' && this.remoteNativeYn === 'Y') {
        return {
          nationality: 'TW',
          nationalReadOnly: true
        }
      }

      const normalizedNationality = apiNationality || ''
      if (isNationalIdentificationNumberValid(idNumber)) {
        return {
          nationality: 'TW',
          nationalReadOnly: true
        }
      }

      const hasNationalityInList = this.countryList.some(item => item.countryCode === normalizedNationality)

      if (normalizedNationality && hasNationalityInList) {
        return {
          nationality: normalizedNationality,
          nationalReadOnly: true
        }
      }

      return {
        nationality: null,
        nationalReadOnly: false
      }
    },
    jobsFilter (item, queryText, itemText) {
      return (
        item.careerCode
          .indexOf(queryText) > -1 ||
        item.careerName
          .indexOf(queryText) > -1
      )
    },
    phoneErrorsHandler (errors, field) {
      const errorsArray = this.$errorMsgHandler(errors)
      const groupRequired = filter(errorsArray, msg =>
        /.*需擇一填入.*/.test(msg)
      )
      if (!field) {
        return groupRequired
      }

      errors = reduce(
        errors,
        (r, v, k) => {
          v = filter(v, msg => !/.*需擇一填入.*/.test(msg))
          const isFieldMatch = k.indexOf(field) > -1
          isFieldMatch && (r[k] = v)
          return r
        },
        {}
      )
      return errors
    },
    doValidate (setDoneFlag) {
      return this.$doValidate('observer').then(isValid => {
        if (!isValid) {
          let num = this.$validateNum('observer')
          this.$emit('set-validate-num', { step: this.tabStep, num })
          if (setDoneFlag) {
            this.$setTabDone(this.tabStep, false )
          }
        } else {
          this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
          if (setDoneFlag) {
            this.$setTabDone(this.tabStep, true )
          }
        }
      })
    },
    getCusInfoData () {
      const { transCode, cusInfo, polInsureType } = this
      const insPolicies = {
        transCode,
        polInsureType,
        stepCode: this.tabStep
      }

      cusInfo.cusType = 'I'
      //fix: SCR #96622 , 修正 BUG ，電話處理過程用 computed 方式會有問題，改用 method
      cusInfo.phoneC = this.phoneCMerge()
      cusInfo.phoneH = this.phoneHMerge()

      if (cusInfo.getDataYn != 'Y') {
        cusInfo.getDataYn = 'N'
      }

      const cus = {
        ...cusInfo,
        transCode
      }

      return {
        insPolicies,
        cus
      }
    },
    checkDecimal (val, m, n) {
      const decimalOrIntegerPattern = /^[0-9]+(\.[0-9]+)?$/
      if (!decimalOrIntegerPattern.test(val)) {
        let num = parseFloat(val)
        if (num) {
          return num + ''
        }
        return ''
      }
      return val
    },
    isEqualFinace (v1, v2) {
      return parseFloat(v1) === parseFloat(v2)
    },
    tempSave: withDebounce(function () {
      let vm = this
      let cusFrom = vm.getCusInfoData()
      vm.postCusInfo(cusFrom).then(() => {
        vm.$setTabDone(this.tabStep, false )
        vm.$alert('暫存成功')
        vm.$postUserAccessLog({ progClassName: 'CusInsured_tempsave', methodName: '暫存', stepCode: vm.tabStep })
      })
    }),
    preStepHandler: withDebounce(function () {
      this.$postUserAccessLog({ progClassName: 'CusInsured_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    }),
    nextStepHandlerController: withDebounce(function () {
      //fix: SCR #96622 ，調整 [地址檢核開關] 參數抓取方式以及在相關判斷前獨立抓取參數
      this.getAjaxInsAddrCheckYn().then(() => {
        this.nextStepHandler()
      })
      // this.$nextTick(() => {
      //   this.nextStepHandler()
      // })
    }),
    nextStepHandler: withDebounce(function () {
      if (!this.cusInfo.cusIdn) {
        this.$alert('請填寫' + this.idnLabel + '!')
        return
      } else if(this.cusInfo.relationOwnerCode ==='2') { // 被保人跟要保人配偶
             let cnt = 0
             if(this.cusInfo.marryCode==='1'){
                cnt = cnt +1
             }
             if(this.cusInfoTypeO.marryCode=='1'){
                cnt = cnt +1
             }
             if(cnt!==2) { // 檢核兩個婚姻
               this.$alert('被保險人與要保人關係之選擇，與要保人、被保險人婚姻狀態不一致，請確認後才能跳至下一步!')
               return
             }
       } else {
        if (this.polInsureType === 'R') {
          let admUsers = this.$store.getters["common/admUserInfo"]
          if (this.cusInfo.cusIdn === admUsers.idno) {
            this.$alert('遠距投保不得為自保件！')
            return
          }
          if (this.remoteNativeYn === 'Y' && !(isNationalIdentificationNumberValid(this.cusInfo.cusIdn))) {
            this.$alert(this.idnLabel + '錯誤!')
            return
          }
        }
        if (!(isNationalIdentificationNumberValid(this.cusInfo.cusIdn) || isResidentCertificateNumberValid(this.cusInfo.cusIdn))) {
          this.$alert(this.idnLabel + '錯誤!')
          return
        }
      }

      this.doValidate()

      let addrValid = false
      // 若「戶籍地址」不為空時，檢核戶籍地址的『完整地址』不為空值或『要保人戶籍地址縣市』不為空值(空白)
      if (this.cusInfo.addrFullR && this.cusInfo.addrFullR.trim()) {
        if (isEmpty(this.addrCheckFullR) && isEmpty(this.cusInfo.addrCityR)) {
          addrValid = true
        }
      }

      if (this.cusInfo.addrFull && this.cusInfo.addrFull.trim()) {
        if (isEmpty(this.addrCheckFull) && isEmpty(this.cusInfo.addrCity)) {
          addrValid = true
        }
      }
      if(addrValid) { // 若上述任一個檢核未通過時，則顯示訊息，按下「確定」後，停留在目前畫面。
        this.$alert('目前地址帶入時未檢核，致無法正確分欄帶入，請點選「地址選擇」重新點選縣市區或等地址資料後再繼續（或通知保經管理人員重新開啟地址檢核）')
          return
      }

      let vm = this
      if (vm.isPreview) {
        vm.checkAgentService({transCode: vm.transCode, delFlag: true }).then(r => {
          let needLegalAgent = false
          if (r.data && r.data.length > 0) {
            r.data.forEach(e => {
              if (e.legalYn === 'Y') {
                needLegalAgent = true
              }
            })
          }
          if (needLegalAgent) {
            vm.$setTabShow('n3', true)
          } else { // 不需要法代，要清法代欄位
            vm.$setTabShow('n3', false)
          }
          vm.$postUserAccessLog({ progClassName: 'CusInsured_next', methodName: '下一步', stepCode: vm.tabStep })
          vm.$nextStepHandler()
        })
        return
      }

      let msg = ''
      // 遠距財務的check
      if (vm.cusFinanceData) {
        if (vm.cusInfo.salary || vm.cusInfo.salary === 0) {
          // 數字轉字串
          vm.cusInfo.salary += ''
        }
        if (vm.cusInfo.salary && !vm.isEqualFinace(vm.cusInfo.salary, vm.cusFinanceData.salary)) {
          if (msg) {
            msg += '、'
          } else {
            msg = '最近一次的'
          }
          msg += '工作年收入-本次：' + vm.cusFinanceData.salary + '萬元'
        }
        if (vm.cusInfo.oIncome || vm.cusInfo.oIncome === 0) {
          // 數字轉字串
          vm.cusInfo.oIncome += ''
        }
        if (vm.cusInfo.oIncome && !vm.isEqualFinace(vm.cusInfo.oIncome, vm.cusFinanceData.oIncome)) {
          if (msg) {
            msg += '、'
          } else {
            msg = '最近一次的'
          }
          msg += '其他年收入-本次：' + vm.cusFinanceData.oIncome + '萬元'
        }
        if (vm.cusInfo.hIncome || vm.cusInfo.hIncome === 0) {
          // 數字轉字串
          vm.cusInfo.hIncome += ''
        }
        if (vm.cusInfo.hIncome && !vm.isEqualFinace(vm.cusInfo.hIncome, vm.cusFinanceData.hIncome)) {
          if (msg) {
            msg += '、'
          } else {
            msg = '最近一次的'
          }
          msg += '家庭年收入-本次：' + vm.cusFinanceData.hIncome + '萬元'
        }
        if (vm.cusInfo.pp || vm.cusInfo.pp === 0) {
          // 數字轉字串
          vm.cusInfo.pp += ''
        }
        if (vm.cusInfo.pp && !vm.isEqualFinace(vm.cusInfo.pp, vm.cusFinanceData.pp)) {
          if (msg) {
            msg += '、'
          } else {
            msg = '最近一次的'
          }
          msg += '總資產_動產-本次：' + vm.cusFinanceData.pp + '萬元'
        }
        if (vm.cusInfo.rp || vm.cusInfo.rp === 0) {
          // 數字轉字串
          vm.cusInfo.rp += ''
        }
        if (vm.cusInfo.rp && !vm.isEqualFinace(vm.cusInfo.rp, vm.cusFinanceData.rp)) {
          if (msg) {
            msg += '、'
          } else {
            msg = '最近一次的'
          }
          msg += '總資產_不動產-本次：' + vm.cusFinanceData.rp + '萬元'
        }


        if (msg) {
          msg += '，與本次輸入不同，請重新修正或修改上一次要保書資料。'
          this.$alert(msg)
          return
        }

      }

      /*
      // 遠距高齡的check
      if (vm.polInsureType === 'R' && vm.cusInfo.birthday) {
        vm.recalculateAge()
        if (!vm.checkRemoteAge()) {
          vm.$alert('因檢核您無完成高齡客戶訓練紀錄，依外規無法銷售保單予高齡(保險年齡滿65歲)之要保人或被保險人')
          return
        }
      }
      */
      // 高齡的check
      if (vm.cusInfo.birthday) {
        vm.recalculateAge()
        if (!vm.checkAge()) {
          vm.$alert('因檢核您無完成高齡客戶訓練紀錄，依外規無法銷售保單予高齡(保險年齡滿65歲)之要保人或被保險人')
          return
        }
      }

      let addressMsg = ''
      if(this.insAddrCheckYn !== 'N'){ // fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
        if (!this.isSameOwner
          && this.cusInfo.addrFullR && !(this.cusInfo.checkAddrRYn === 'Y'
          || this.cusInfo.checkAddrRYn === 'P')) {
          addressMsg += '戶籍地址未正規化!'
        }
        if (!this.isSameOwner
          && this.cusInfo.addrFull && this.cusInfo.sameAddrYn !== 'Y' && !(this.cusInfo.checkAddrYn === 'Y'
          || this.cusInfo.checkAddrYn === 'P')) {
          if (addressMsg) {
            addressMsg += '<br>'
          }
          addressMsg += '住家地址未正規化!'
        }
        if (addressMsg) {
          let newMsg = this.changeMsg(addressMsg.split('<br>'))
          this.$alert(newMsg)
          return
        }
      }
      const saveHandler = () => {
        let cusFrom = vm.getCusInfoData()
        vm.postCusInfo(cusFrom).then(() => {
          // 存完後，判斷是否要出現法代
          vm.checkAgentService({transCode: vm.transCode, delFlag: true }).then(r => {
            let needLegalAgent = false
            if (r.data && r.data.length > 0) {
              r.data.forEach(e => {
                if (e.legalYn === 'Y') {
                  needLegalAgent = true
                }
              })
            }
            if (needLegalAgent) {
              vm.$setTabShow('n3', true)
            } else {
              // 不需要法代，要清法代欄位
              vm.$setTabShow('n3', false)
            }
            vm.doValidate(true).then(() => {
              vm.$postUserAccessLog({ progClassName: 'CusInsured_next', methodName: '下一步', stepCode: vm.tabStep })
              vm.$nextStepHandler()
            })
          })
        })
      }

      let fAmlCheck = () => {
        addrRCheck()
      }

      let addrCheckErrorMsg = ''
      let addressPass = true
      let addrRCheck = () => {
        addrCheck()
      }
      let addrCheck = () => {
        if (addrCheckErrorMsg) {
          let newMsg = this.changeMsg(addrCheckErrorMsg.split('<br>'))
          this.$alert(newMsg, () => {
            if (addressPass) {
              saveHandler()
            }
          })
        } else {
          saveHandler()
        }
      }

      if (this.cusTypeIAddressRCheck !== 'Y' && !this.isSameOwner) {
        if (this.cusInfo.addrFullR) {
          addrRCheck = () => {
            if(this.insAddrCheckYn === 'N'){ // fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
              //需補上對應參數變更
              this.cusInfo.checkAddrRYn = 'N' // 地址正規化成功
              this.cusTypeIAddressRCheck = 'Y'
              this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              addrCheck()
              return
            }
            const addrFullR = this.getFullAddrR_forCheck()
            this.addressCheck(addrFullR, this.transCode, this.compCode).then(r => {
              if (r.connectError) {
                addrCheckErrorMsg += '戶籍地址正規化檢核連線失敗！關閉訊息後系統將留存您原輸入之地址後跳下一步'

                this.cusInfo.checkAddrRYn = 'P' // 地址正規化，api錯誤
                this.cusTypeIAddressRCheck = 'Y'
                this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              } else if (r.code === 'ok1' || r.code === 'ok2') {
                this.cusInfo.checkAddrRYn = 'Y' // 地址正規化成功
                this.cusTypeIAddressRCheck = 'Y'
                this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              } else {
                addrCheckErrorMsg += '戶籍' + r.msg
                addressPass = false
              }
              addrCheck()

            })
          }
        }
      }
      if (this.cusTypeIAddressCheck !== 'Y' && this.cusInfo.sameAddrYn !== 'Y' && !this.isSameOwner) {
        if (this.cusInfo.addrFull) {
          addrCheck = () => {
            if(this.insAddrCheckYn === 'N'){ // fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
              //需補上對應參數變更
              this.cusInfo.checkAddrYn = 'N' // 地址正規化成功
              this.cusTypeIAddressCheck = 'Y'
              this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              saveHandler()
              return
            }
            const addrFull = this.getFullAddr_forCheck()
            this.addressCheck(addrFull, this.transCode, this.compCode).then(r => {
              if (r.connectError) {
                if (addrCheckErrorMsg) {
                  addrCheckErrorMsg += '<br>'
                }
                addrCheckErrorMsg += '住所地址正規化檢核連線失敗！關閉訊息後系統將留存您原輸入之地址後跳下一步'

                this.cusInfo.checkAddrYn = 'P' // 地址正規化，api錯誤
                this.cusTypeIAddressCheck = 'Y'
                this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              } else if (r.code === 'ok1' || r.code === 'ok2') {
                this.cusInfo.checkAddrYn = 'Y' // 地址正規化成功
                this.cusTypeIAddressCheck = 'Y'
                this.$emit('update-cus-type-i-address-status', { cusTypeIAddressRCheck: this.cusTypeIAddressRCheck, cusTypeIAddressCheck: this.cusTypeIAddressCheck })
              } else {
                if (addrCheckErrorMsg) {
                  addrCheckErrorMsg += '<br>'
                }
                addrCheckErrorMsg += '住所' + r.msg
                addressPass = false
              }
              if (addrCheckErrorMsg) {
                let newMsg = this.changeMsg(addrCheckErrorMsg.split('<br>'))
                this.$alert(newMsg, () => {
                  if (addressPass) {
                    saveHandler()
                  }
                })
              } else {
                saveHandler()
              }

            })
          }
        }
      }


      if (vm.cusTypeICheck !== 'Y' && !vm.isSameOwner) {
        fAmlCheck = () => {
          vm.checkCusName({ transCode: vm.transCode, compCode: vm.compCode, idnCardList: [vm.cusInfo.cusIdn] }).then(r => {
            if (r.data.status === 'E'&& !isDev) {// 失敗，dev pass判斷
              vm.$alert(r.data.message)
            } else if(r.data.status === 'M') {// 複選
              vm.$alert(r.data.message).then(() => {
                vm.cusInfo.amlResult = r.data.amlResult
                vm.cusTypeICheck = 'Y'
                vm.$emit('update-type-i-status', vm.cusTypeICheck)

                addrRCheck()
              })
            } else { // 成功
              vm.cusInfo.amlResult = r.data.amlResult
              vm.cusTypeICheck = 'Y'
              vm.$emit('update-type-i-status', this.cusTypeICheck)

              addrRCheck()
            }
          })
        }
      }

      fAmlCheck()

    })
  }

}
</script>
